import { type FC, type RefCallback } from 'react'
import type { Project } from '@/types'
import { ProjectGridCell } from '@/components/projectCell/ProjectGridCell'
import type { AllProjectCountersWithOverdue } from '@/queries/projectCounters'

interface IProps {
  projects: Project[]
  counts?: AllProjectCountersWithOverdue
  fromProjectId?: number
}

const scrollCellIntoView: RefCallback<HTMLAnchorElement> = element =>
  element?.scrollIntoView({ behavior: 'instant', block: 'center' })

export const GridMode: FC<IProps> = ({ projects, counts, fromProjectId }) => {
  const cells = projects.map((p, i) => (
    <ProjectGridCell
      ref={p.get('idd') === fromProjectId ? scrollCellIntoView : undefined}
      key={i}
      project={p!}
      counts={counts?.[p.get('idd')]}
      className={p.get('idd') === fromProjectId ? 'border border-solid border-neutral-400 dark:border-neutral-500' : ''}
    />
  ))
  return (
    <div className="mb-2 flex flex-row flex-wrap items-center justify-evenly md:mx-2 md:justify-start">{cells}</div>
  )
}
